import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'

import { Query } from 'react-apollo'
import {
  PROJECT_TIME_REQUISITION_QUERY,
  PROJECT_SPLITTED_TIME_REQUISITION_QUERY,
} from './projectTimeRequisitionQuery'

import isNil from 'lodash/isNil'
import get from 'lodash/get'

import { getProjectId } from 'utils'

import PageLayout from 'components/layout/pageLayout'
import SubNavigation from 'components/layout/subNavigation'
import Head from 'components/layout/head'
import Table from 'components/layout/table'
import TableResult from 'components/layout/tableResult'
import CheckBox from 'components/ui/checkBox'

import timeRequirementConfig from './timeRequirementTable.config'
import timeRequirementResultConfig from './timeRequirementTableResult.config'
import timeRequirementResultAllPositionsConfig from './timeRequirementTableResultAllPositions.config'
import Loader from 'components/ui/loader'

interface ProjectTimeRequirementProps extends RouteComponentProps<any> {
  authenticated: boolean
}

type ProjectTimeRequirementState = {
  splitCalculation: boolean
}

class ProjectTimeRequirement extends Component<
  ProjectTimeRequirementProps,
  ProjectTimeRequirementState
> {
  constructor(props: ProjectTimeRequirementProps) {
    super(props)
    this.state = {
      splitCalculation: false,
    }
  }

  handleSplitCalculation = (value: boolean) => {
    this.setState({ splitCalculation: value })
  }

  transformActivities = (activities: any) => {
    if (isNil(activities)) return null

    return activities.map((activity: any) => {
      Object.keys(activity).map((key: string) => {
        if (!isNil(activity[key]) && !activity[key].hasOwnProperty('value')) {
          switch (key) {
            case 'amount':
              activity[key] = { value: activity[key], unit: activity.unit }
              break
          }
        }
        return null
      })
      return activity
    })
  }

  render() {
    const id = getProjectId(this.props)
    const { splitCalculation } = this.state

    return (
      <PageLayout pageTitle="Projekte">
        <Head
          subheadline={
            process.env.REACT_APP_ENV === 'rigips'
              ? 'Mengenermittlung und Systemsuche - HORST'
              : 'ABK calcKit – der Baukasten für die schnelle Kalkulation'
          }
          headline={get(this.props, 'projectData.getProject.projectName')}
        />
        <SubNavigation
          items={[
            {
              label: 'Übersicht',
              link: `/projects/${id}`,
            },
            {
              link: `/projects/${id}/material-requirement`,
              label: 'Materialbedarf',
            },
            {
              link: `/projects/${id}/time-requirement`,
              label: 'Zeitbedarf',
            },
            {
              link: `/projects/${id}/settings`,
              label: 'Einstellungen',
            },
          ]}
          actions={
            <>
              <CheckBox
                checked={splitCalculation}
                onChange={(value) => this.handleSplitCalculation(value)}
                value="splitCalc"
                label="Aufteilen in Kalkulationen"
              />
            </>
          }
        />

        {!splitCalculation ? (
          <Query
            query={PROJECT_TIME_REQUISITION_QUERY}
            fetchPolicy="network-only"
            variables={{ projectId: id }}
          >
            {({ loading, data }: any | null) => {
              const activities = get(data, 'getProjectsTimeRequisition.activities', [])
              const totalPrice = get(data, 'getProjectsTimeRequisition.totalPrice', [])
              const totalTime = get(data, 'getProjectsTimeRequisition.totalTime', [])

              return (
                <div className="mb-65">
                  <h1 className="mx-48 section-heading">Zeitbedarf (alle Positionen zusammen)</h1>
                  <Table
                    config={timeRequirementConfig}
                    isLoading={loading}
                    data={this.transformActivities(activities)}
                  />
                  <div className="mt-30">
                    <TableResult
                      config={timeRequirementResultConfig}
                      data={[
                        {
                          desc: 'Summe Zeitbedarf Gesamt',
                          totalPrice,
                          totalTime,
                        },
                      ]}
                    />
                  </div>
                </div>
              )
            }}
          </Query>
        ) : (
          <>
            <Query
              query={PROJECT_SPLITTED_TIME_REQUISITION_QUERY}
              fetchPolicy="network-only"
              variables={{ projectId: id }}
            >
              {({ loading, data }: any | null) => {
                if (loading) return <Loader />

                const positions = get(data, 'getProjectsSplittedTimeRequisition.activities', [])
                const totalTime = get(data, 'getProjectsSplittedTimeRequisition.totalTime', 0)
                const totalPrice = get(data, 'getProjectsSplittedTimeRequisition.totalPrice', 0)

                return (
                  <>
                    {positions.map((position: any, index: number) => {
                      return (
                        <div key={index} className="mb-65">
                          {position.elementName && (
                            <h1 className="mx-48 section-heading">{position.elementName}</h1>
                          )}
                          <Table
                            config={timeRequirementConfig}
                            data={this.transformActivities(position.activities)}
                          />
                          <div className="mt-30">
                            <TableResult
                              config={timeRequirementResultConfig}
                              data={[
                                {
                                  desc: 'Summe Zeitbedarf Gesamt',
                                  totalPrice: position.totalPrice,
                                  totalTime: position.totalTime,
                                },
                              ]}
                            />
                          </div>
                        </div>
                      )
                    })}
                    <div className="mb-65">
                      <TableResult
                        config={timeRequirementResultAllPositionsConfig}
                        data={[
                          {
                            totalTime,
                            totalPrice,
                          },
                        ]}
                      />
                    </div>
                  </>
                )
              }}
            </Query>
          </>
        )}
      </PageLayout>
    )
  }
}

export default ProjectTimeRequirement
